import { RefObject, useEffect, useRef } from 'react'

// Локальная копия useValueRef — у библиотеки персиста не должно быть внешних зависимостей.
// Основной useValueRef приложения — shared/hooks/useValueRef.
export const useValueRef = <T>(value: T): RefObject<T> => {
  const ref = useRef<T>(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref
}
